<!-- @format -->

<template>
    <div>
        <div class="package-offer-not-available-modal rounded-lg">
            <div class="package-offer-not-available-modal__content d-flex align-center">
                <p>{{ $t('title') }}</p>
            </div>
            <hr
                v-if="$vuetify.breakpoint.mdAndUp"
                class="package-offer-not-available-modal__divider"
                role="presentation"
                aria-orientation="horizontal" />
            <div class="package-offer-not-available-modal__button d-flex justify-end align-center">
                <BaseButton
                    color="primary"
                    :placeholder="$t('button')"
                    @click="$emit('close')" />
            </div>
        </div>
    </div>
</template>

<script>
import CloseModalOnRouteChangeMixin from '@core/mixins/modals/CloseModalOnRouteChange';

export default {
    name: 'PackageOfferUnavailableModal',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'views.eventV2.theEvent._components.packageOfferNotAvailableModal',
    },
    mixins: [CloseModalOnRouteChangeMixin],
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';

.package-offer-not-available-modal {
    background-color: theme-color('white') !important;
    min-height: 148px;

    .package-offer-not-available-modal__content {
        height: 50%;
        padding-top: theme-spacing(6) !important;
        overflow-wrap: break-word;

        p {
            font-size: font-size('xxxxl');
            font-weight: font-weight(large);
            margin-left: theme-spacing(8);
        }
    }

    .package-offer-not-available-modal__divider {
        border: solid;
        border-width: 1px !important;
        border-color: #e3e4e5;
    }

    .package-offer-not-available-modal__button {
        height: 50%;
        padding-top: theme-spacing(6) !important;
        padding-bottom: theme-spacing(6) !important;

        button {
            margin-right: theme-spacing(5);
            font-size: font-size('s') !important;
            font-weight: font-weight(bold);
        }
    }
}

@include mobile-only {
    .package-offer-not-available-modal__content {
        height: 50%;
        padding-top: theme-spacing(4) !important;
        justify-content: center;

        p {
            font-size: font-size('l') !important;
            font-weight: font-weight(large);
            margin-left: theme-spacing(8);
        }
    }
}
</style>
